import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ValidationErrors } from '@angular/forms';

@Component({
  selector: 'fb-field-tooltip-password-rules',
  templateUrl: './field-tooltip-password-rules.component.html',
  styleUrls: ['./field-tooltip-password-rules.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FieldTooltipPasswordRulesComponent {
  @Input() errors: ValidationErrors | null;
  @Input() minlength: string;
}
